import { Card } from "@heroui/react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import type { PeriodStatPoint } from "../model/types";
import { CustomTooltip } from "./CustomTooltip";

export interface StatisticsSpentChartProps {
  data: PeriodStatPoint[];
}

export const StatisticsSpentChart = ({ data }: StatisticsSpentChartProps) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="text-xs text-neutral-400">Расход и клики</div>
      <Card className="p-4">
        <div className="h-60 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={data}
              margin={{ top: 8, right: 0, left: -15, bottom: 0 }}
            >
              <defs>
                <linearGradient id="spentGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#0ea5e9" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#0ea5e9" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="clicksGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="rgba(255,255,255,0.06)"
                vertical={false}
              />
              <XAxis
                dataKey="date"
                stroke="#737373"
                fontSize={11}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                yAxisId="spent"
                stroke="#737373"
                fontSize={11}
                tickLine={false}
                axisLine={false}
                tickFormatter={(val) =>
                  val >= 1000 ? `${Math.round(val / 1000)}k` : `${val}`
                }
              />
              <YAxis
                yAxisId="clicks"
                orientation="right"
                stroke="#737373"
                fontSize={11}
                tickLine={false}
                axisLine={false}
                tickFormatter={(val) => `${val}`}
              />
              <Tooltip
                content={<CustomTooltip />}
                cursor={{
                  stroke: "rgba(255, 255, 255, 0.2)",
                  strokeWidth: 1,
                  strokeDasharray: "2 2",
                }}
              />
              <Area
                yAxisId="spent"
                type="monotone"
                dataKey="spent"
                name="Расход"
                stroke="#0ea5e9"
                strokeWidth={2}
                fill="url(#spentGradient)"
                activeDot={{
                  r: 4,
                  fill: "#0ea5e9",
                  stroke: "#ffffff",
                  strokeWidth: 2,
                }}
              />
              <Area
                yAxisId="clicks"
                type="monotone"
                dataKey="clicks"
                name="Клики"
                stroke="#8b5cf6"
                strokeWidth={2}
                fill="url(#clicksGradient)"
                activeDot={{
                  r: 4,
                  fill: "#8b5cf6",
                  stroke: "#ffffff",
                  strokeWidth: 2,
                }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
};
